import { pageTitle } from 'ember-page-title';
import MmNavbar from 'marcemira/components/mm-navbar';
import MetaTags from 'marcemira/components/meta-tags';
import autoAnimateModifier from 'marcemira/modifiers/auto-animate';

<template>
  {{pageTitle "Marcemira"}}
  <MetaTags />

  <a href="#main-content" class="skip-to-content">
    Skip to main content
  </a>

  <MmNavbar @iconFlipped={{@controller.iconFlipped}} />

  <main class="container" id="main-content" tabindex="-1">
    <div {{autoAnimateModifier}}>
      {{outlet}}
    </div>
  </main>
</template>
